import { screenRoles } from "./screenRoles";

export class searchResult<T> {
  count: number;
  result: T;
  screenRoles?: screenRoles;

  constructor(item?: searchResult<T>) {
    this.result = item?.result;
    this.count = item?.count;
    this.screenRoles = item?.screenRoles;
  }
}
